<div class="chat-integrated-container">
  <div class="chat-header">
    <span class="title">Trace Fornecedores</span>
    <span class="subtitle">Assistente de Análise de Fornecedores</span>
    <button mat-icon-button (click)="clearChat()" title="Limpar Conversa">
      <fa-icon [icon]="faTrash"></fa-icon>
    </button>
  </div>

  <div class="chat-messages">
    <div *ngFor="let message of messages" class="message-row" [ngClass]="{'user': message.sender === 'user', 'ai': message.sender === 'ai'}">
      <div class="message-bubble">
        <p>{{ message.text }}</p>
        <div *ngIf="message.actionButton" class="action-button-container">
          <button mat-raised-button color="primary" (click)="handleMessageAction(message.actionButton.route)">
            {{ message.actionButton.label }}
          </button>
        </div>
        <span class="message-time">{{ message.time }}</span>
      </div>
    </div>
  </div>

  <div *ngIf="messages.length === 1" class="suggested-actions">
    <p>Sugestões:</p>
    <button mat-button *ngFor="let action of suggestedActions" (click)="handleSuggestedAction(action)">
      {{ action }}
    </button>
  </div>

  <div class="chat-input">
    <mat-form-field appearance="outline" class="full-width-input">
      <input matInput placeholder="Digite sua mensagem..." [(ngModel)]="newMessage" (keyup.enter)="sendMessage()">
      <button mat-icon-button matSuffix color="primary" (click)="sendMessage()" [disabled]="!newMessage.trim()">
        <fa-icon [icon]="['fas', 'paper-plane']"></fa-icon>
      </button>
    </mat-form-field>
  </div>
</div>